import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { Descriptions, Empty, Tooltip } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useMetaTranslate } from "../hooks/useMetaTranslate";

type Props = {
  source: Source;
};

export const SourceMetaItem = observer((props: Props) => {
  const mt = useMetaTranslate();
  const [metaFields, setMetaFields] = useState<string[]>([]);

  useEffect(() => {
    if (props.source?.meta?.data) {
      setMetaFields(Object.keys(props.source.meta.data));
    }
  }, [props.source]);

  const items: DescriptionsItemType[] = metaFields?.map((metaField) => ({
    label: <Tooltip title={metaField}>{mt(metaField)}</Tooltip>,
    children: props?.source?.meta?.data[metaField],
  }));

  return (
    <>
      {items.length > 0 && <Descriptions items={items} bordered size="small" />}
      {items.length === 0 && <Empty />}
    </>
  );
});
